import React from "react";

function InputText({ id, label, name, type = "text", value, onChange, placeholder }) {
  const inputId = id || name || "text-input";

  return (
    <>
      <label htmlFor={inputId}>{label}</label>
      <input
        autoComplete="none"
        className="Input"
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </>
  );
}

export default InputText;
